module.exports = __webpack_public_path__ + "img/kv_title1.e0af92c9.png";